import { Provider } from "react-redux";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";

import storeCreator from "./store";

import AppRouter from "./views/AppRouter";

import { PersistGate } from "redux-persist/integration/react";

import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";

setupLogRocketReact(LogRocket);

if (process.env.REACT_APP_LOG_ROCKET) {
	setupLogRocketReact(LogRocket);

	LogRocket.init(process.env.REACT_APP_LOG_ROCKET, {
		network: {
			requestSanitizer: (request: any) => {
				if (request.body && request.body.indexOf("password") > -1) {
					const body = JSON.parse(request.body);

					if (body.password) body.password = null;

					request.body = JSON.stringify(body);
				}

				// request.headers["Authorization"] = null;

				return request;
			}
		}
	});
}

const { store, persistor } = storeCreator();

const theme = createTheme({
	typography: {
		fontFamily: "'Montserrat', sans-serif;"
	},
	palette: {
		primary: {
			light: "#00acbb",
			main: "#008bba",
			dark: "#707070"
		}
	}
});

function App() {
	return (
		<div className="App">
			<HelmetProvider>
				<ThemeProvider theme={theme}>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<Provider store={store}>
							<PersistGate loading={null} persistor={persistor}>
								<BrowserRouter>
									<AppRouter />
								</BrowserRouter>
							</PersistGate>
						</Provider>
					</LocalizationProvider>
				</ThemeProvider>
			</HelmetProvider>
		</div>
	);
}

export default App;
